import React from 'react';

import Details from './Details';

import List from './List';
import Manage from './Manage';
import { Route, Switch } from 'react-router';
import { routes } from '../../../shared/constants/routes';

function LoraDevicesRoutes() {
  return (
    <>
      <Switch>
        <Route path={routes.lora.devices.default.path} exact component={List} />
        <Route path={routes.lora.devices.details.path} exact component={Details} />
        <Route path={routes.lora.devices.create.path} exact component={Manage} />
        <Route path={routes.lora.devices.edit.path} exact component={Manage} />
      </Switch>
    </>
  );
}

export default LoraDevicesRoutes;
